import React from 'react';
import InteractiveButton from './InteractiveButton';
import styles from '../styles';

export default function ProjectsList({ projects = [], linkFontSize = 16, linkPadding = '14px 18px', linkRadius = 28 }) {
	return (
		<>
			{projects.map((project) => (
				<div key={project.id}>
					<InteractiveButton
						href={project.link}
						target="_blank"
						rel="noopener noreferrer"
						style={{
							...styles.linkButton,
							fontSize: linkFontSize,
							padding: linkPadding,
							borderRadius: linkRadius,
							boxShadow: project.id === 'portfolio' ? '3px 3px 0 #b6fa18' : styles.linkButton.boxShadow,
						}}
						ariaLabel={`${project.name} - abrir enlace`}
					>
						{project.name}
					</InteractiveButton>
				</div>
			))}
		</>
	);
}
